import { useCallback, useEffect } from 'react'
import { IDBPDatabase, openDB } from 'idb'

export const INDEXED_DB_NAME = 'Scoreboard'
export const INDEXED_DB_VERSION = 1

export interface UseIndexedDbOptions {
  tableNames: string[]
}

function useIndexedDb(props: UseIndexedDbOptions) {
  const { tableNames } = props

  const initIndexedDB = useCallback(async () => {
    await openDB(INDEXED_DB_NAME, INDEXED_DB_VERSION, {
      upgrade(db: IDBPDatabase) {
        for (const tableName of tableNames) {
          if (db.objectStoreNames.contains(tableName)) {
            continue
          }
          db.createObjectStore(tableName, { autoIncrement: true, keyPath: 'id' }).createIndex('name', 'name', {
            unique: false,
          })
        }
      },
    })
  }, [])

  const putValue = useCallback(async (tableName: string, value: object) => {
    let dbr = await openDB(INDEXED_DB_NAME, INDEXED_DB_VERSION)
    if (dbr) {
      const tx = dbr.transaction(tableName, 'readwrite')
      const store = tx.objectStore(tableName)
      const result = await store.put(value)
      return result
    }
  }, [])

  const getValue = useCallback(async (tableName: string, index: string, value: string) => {
    let dbr = await openDB(INDEXED_DB_NAME, INDEXED_DB_VERSION)
    if (dbr) {
      const tx = dbr.transaction(tableName, 'readonly')
      const store = tx.objectStore(tableName)
      const myIndex = store.index(index)
      const result = await myIndex.get(value)
      return result
    }
  }, [])

  useEffect(() => {
    initIndexedDB().catch(console.error)
  }, [initIndexedDB])

  return [{ putValue, getValue }] as const
}

export default useIndexedDb
